import React, { FC, ReactElement, ReactNode, useState } from 'react';
import { Collapse } from 'react-bootstrap';

type TherapySectionProps = {
  eventKey: string;
  title: string;
  icon?: string;
  description?: string;
  children: ReactNode;
};

const TherapySection: FC<TherapySectionProps> = ({
  eventKey,
  title,
  icon,
  description,
  children,
}: TherapySectionProps): ReactElement => {
  const [open, setOpen] = useState(true);

  const bodyId: string = `therapy-section-${eventKey}`;

  const toggle = (): void => setOpen((current: boolean) => !current);

  return (
    <div className="bg-white border rounded-3 shadow-sm overflow-hidden">
      <div className="d-flex align-items-center justify-content-between gap-3 px-4 py-3">
        <button
          type="button"
          className="btn d-flex align-items-center gap-3 text-start text-reset flex-grow-1 p-0 border-0 shadow-none"
          onClick={toggle}
          aria-expanded={open}
          aria-controls={bodyId}
        >
          {icon && <i className={`${icon} fs-5`} style={{ color: '#234a68' }} aria-hidden="true" />}

          <span className="flex-grow-1">
            <span className="d-block fs-5 fw-semibold">{title}</span>
            {description && <span className="d-block small text-muted">{description}</span>}
          </span>

          <span
            className="ms-2 d-inline-flex align-items-center"
            style={{
              color: '#234a68',
              transition: 'transform 0.2s ease',
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <i className="fas fa-chevron-down fs-4" aria-hidden="true" />
          </span>
        </button>
      </div>

      <Collapse in={open}>
        <div id={bodyId}>
          <div className="px-4 pb-4 pt-3 border-top">{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default TherapySection;
